import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { CSVLink } from "react-csv";
import React, { useState, useEffect } from "react";
import { useMemo } from "react";
import _ from "lodash";
import moment from "moment";
export default function ExportReportModal(props) {
  const [courseReport, setCourseReport] = useState([]);

  const [topicList, setTopiclist] = useState([]);

  const [isCheckAll, setIsCheckAll] = useState(true);
  const [isCheckAllGeneral, setIsCheckAllGeneral] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [normalizedEnrolledUsers, setNormalizedEnrolledUsers] = useState([]);
  const isCoke = props?.courseId === 302;

  const [removedKey, setRemovedKey] = useState([
    "name",
    "id",
    "course_id",
    "section",
    "Module",
  ]);

  useEffect(() => {
    const { reports, courseTopics } = props;

    //Remove Unwanted key form array of objects
    const newReportArr = _.map(reports, function (row) {
      return _.omit(row, removedKey);
    });
    setCourseReport(newReportArr);

    //Lesson topics
    const topics = courseTopics?.courses_course_module_mapping.map((e) => {
      return {
        id: e.id,
        name: e.name,
      };
    });
    setTopiclist(topics);
  }, [props]);

  // Add/Remove checked item from list
  const handleCheck = (event) => {
    let updatedList = [...props?.ischecked];
    if (event.target.checked) {
      updatedList = [...props?.ischecked, parseInt(event.target.value)];
    } else {
      updatedList.splice(
        props?.ischecked.indexOf(parseInt(event.target.value)),
        1,
      );
    }

    props.handleChecked(updatedList);
  };

  // Set Enrolled Users Report Csv Header
  const baseHeaders = [
    { label: "Student Id", key: "user_id" },
    { label: "Student Name", key: "user.name" },
    { label: "Email", key: "user.email" },
    { label: "Phone", key: "user.mobile_number" },
    { label: "Course Name", key: "course_obj_relation.full_name" },
    { label: "Enroll Status", key: "enroll_status" },
    { label: "Enroll Date", key: "created_at" },
  ];

  // Set course progress Report General Columns or Header

  const GeneralHeaders = [
    // { label: "skillstrainer student id", key: "skillstrainer_student_id" },
    // { label: "Course Name", key: "course_name" },
    // { label: "Nsqf Level", key: "nsqf_level" },
    // { label: "Salutation", key: "salutation" },
    { label: "Username", key: "username" },
    { label: "Email", key: "useremail" },
    // { label: "Father Name", key: "father_name" },
    { label: "Mobile", key: "mobile_number" },
    // { label: "D.O.B", key: "date_of_birth" },
    { label: "Gender", key: "gender" },
    // { label: "Permanent Address Line", key: "permanent_address_line" },
    // { label: "Country", key: "country" },
    // { label: "City Town", key: "city_town" },
    // { label: "District", key: "district" },
    // { label: "State", key: "state" },
    // { label: "Pincode", key: "pincode" },

    // { label: "Client Student ID", key: "client_student_id" },
    // { label: "Client Batch ID", key: "client_batch_id" },
    // { label: "Partner User Slot Number", key: "partner_user_slot_number" },
    // { label: "Is Currently Working", key: "is_currently_working" },
    // { label: "Job Requirement", key: "job_requirement" },

    // { label: "Partner Id", key: "partner_id" },
    // { label: "SkillsTrainer Batch ID", key: "skillstrainer_batch_id" },
    // { label: "Partner Name", key: "partner_name" },
    { label: "Course Enrollment Date", key: "course_enrollment_date" },
    { label: "Course Start Date", key: "course_start_date" },
    { label: "Course Completion Date", key: "course_completion_date" },
  ];

  //All select topics handler
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    props.topicSelectAll(!isCheckAll);
  };

  // All select general
  const handleSelectAllGeneral = (event) => {
    setIsCheckAllGeneral(!isCheckAllGeneral);
    if (event.target.checked) {
      setRemovedKey(["name", "id", "course_id", "section", "Module"]);
    } else {
      setRemovedKey((oldarray) => [
        ...oldarray,
        // "skillstrainer_student_id",
        // "course_name",
        // "salutation",
        "username",
        "useremail",
        // "nsqf_level",
        // "father_name",
        "mobile_number",
        // "date_of_birth",
        "gender",
        // "permanent_address_line",
        // "country",
        // "city_town",
        // "district",
        // "state",
        // "pincode",
        // "is_currently_working",
        // "job_requirement",
        // "client_student_id",
        // "client_batch_id",
        // "partner_user_slot_number",
        // "partner_id",
        // "skillstrainer_batch_id",
        // "partner_name",
        "course_enrollment_date",
        "course_start_date",
        "course_completion_date",
      ]);
    }
  };

  const handleCheckGeneral = (event) => {
    let updatedList = [...removedKey];
    if (event.target.checked) {
      updatedList.splice(removedKey.indexOf(event.target.value), 1);
    } else {
      updatedList = [...removedKey, event.target.value];
    }
    setRemovedKey(updatedList);
  };

  useEffect(() => {
    const filterReport = _.map(props?.reports, function (row) {
      return _.omit(row, removedKey);
    });
    setCourseReport(filterReport);
  }, [removedKey]);

  useEffect(() => {
    if (!props.enrolledUsers) return;
    if (!isCoke) {
      setNormalizedEnrolledUsers(props.enrolledUsers);
      return;
    }
    const normalized = _.map(props.enrolledUsers, function (row) {
      return {
        ...row,
        user: {
          ...row?.user,
          state: row?.user?.state || row?.user?.address?.state || "",
          district: row?.user?.district || row?.user?.address?.district || "",
        },
      };
    });
    setNormalizedEnrolledUsers(normalized);
  }, [props.enrolledUsers, isCoke]);

  const headers = useMemo(() => {
    if (isCoke) {
      return [
        ...baseHeaders,
        { label: "State", key: "user.state" },
        { label: "District", key: "user.district" },
      ];
    }
    return baseHeaders;
  }, [isCoke]);
  const filteredEnrolledUsers = useMemo(() => {
    if (!props.enrolledUsers) return [];
    return props.enrolledUsers.filter((row) => {
      if (!startDate && !endDate) return true;
      // created_at is ISO timestamp e.g. "2026-05-07T08:58:42.248291+00:00"
      const enrolledDate = moment(row.created_at);
      if (startDate && endDate) {
        return enrolledDate.isBetween(
          moment(startDate).startOf("day"),
          moment(endDate).endOf("day"),
          null,
          "[]",
        );
      } else if (startDate) {
        return enrolledDate.isSameOrAfter(moment(startDate).startOf("day"));
      } else if (endDate) {
        return enrolledDate.isSameOrBefore(moment(endDate).endOf("day"));
      }
      return true;
    });
  }, [props.enrolledUsers, startDate, endDate]);

  return (
    <Tabs
      defaultActiveKey="enrolled_users"
      id="justify-tab-example"
      className="mb-3"
      justify
    >
      <Tab eventKey="enrolled_users" title="Enrolled Users">
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            From Date
          </label>
          <input
            type="date"
            className="border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            To Date
          </label>
          <input
            type="date"
            className="border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        {(startDate || endDate) && (
          <div className="flex flex-col justify-end">
            <label className="text-sm font-medium text-transparent mb-1">
              &nbsp;
            </label>
            <button
              className="border border-gray-400 rounded px-3 py-2 text-sm text-gray-600 hover:bg-gray-100"
              onClick={() => {
                setStartDate("");
                setEndDate("");
              }}
            >
              Clear Filter
            </button>
            <div className="flex flex-col justify-end">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Filtered Records
              </label>
              <span className="text-sm text-gray-600 py-2">
                {filteredEnrolledUsers.length} user(s)
              </span>
            </div>
          </div>
        )}
        {props.enrolledUsers ? (
          <CSVLink
            className="no-underline bg-orange p-2 rounded-md text-white my-5 mx-4"
            filename="Enrolled Users"
            data={normalizedEnrolledUsers}
            headers={headers}
            target="_blank"
          >
            Export Enrolled List as CSV
          </CSVLink>
        ) : (
          "<h2>Sorry, No Enrolled Users Found In This Course</h2>"
        )}
      </Tab>
      <Tab eventKey="user_course_report" title="User Course Reports">
        <div className="flex flex-row pl-40">
          <div className="w-full">
            <h3 className="text-center font-semibold">Select Course Topics</h3>
            <div className="flex items-center">
              <input
                type="checkbox"
                className="h-7 w-7 focus:ring-0 
          focus:ring-offset-0 focus:border-0 rounded"
                onChange={handleSelectAll}
                checked={isCheckAll}
              ></input>
              <label
                htmlFor="comments"
                className="ml-3 text-sm font-medium text-gray-700"
              >
                Select All
              </label>
            </div>
            <ul className="toppings-list overflow-y-scroll	h-screen w-full	">
              {topicList?.map(({ id, name }) => {
                return (
                  <li key={id}>
                    <div className="toppings-list-item">
                      <div className="left-section">
                        <input
                          type="checkbox"
                          id={`custom-checkbox-${id}`}
                          name={name}
                          value={id}
                          onChange={handleCheck}
                          // defaultChecked={true}
                          checked={props?.ischecked.includes(id)}
                        />
                        <label htmlFor={`custom-checkbox-${id}`}>{name}</label>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="w-full">
            <h3 className="text-center font-semibold">Select General Topics</h3>
            <div className="flex items-center justify-between">
              <div className="mx-2">
                <input
                  type="checkbox"
                  className="h-7 w-7 focus:ring-0 
          focus:ring-offset-0 focus:border-0 rounded"
                  onChange={handleSelectAllGeneral}
                  checked={isCheckAllGeneral}
                ></input>

                <label
                  htmlFor="comments"
                  className="ml-3 text-sm font-medium text-gray-700"
                >
                  Select All
                </label>
              </div>

              {topicList && topicList.length > 0 ? (
                <CSVLink
                  className="no-underline bg-orange p-2 rounded-md text-white my-5 mx-2  items-center "
                  filename="Users Progress Report"
                  data={courseReport}
                  target="_top"
                >
                  Export User Topics Progress as CSV
                </CSVLink>
              ) : (
                "Sorry, No Modules Added In This Course"
              )}
            </div>
            <ul className="toppings-list overflow-y-scroll	h-screen w-full	">
              {GeneralHeaders?.map(({ label, key }) => {
                return (
                  <li key={key}>
                    <div className="toppings-list-item">
                      <div className="left-section">
                        <input
                          type="checkbox"
                          id={`custom-checkbox-${key}`}
                          name={label}
                          value={key}
                          onChange={handleCheckGeneral}
                          checked={!removedKey.includes(key)}
                        />
                        <label htmlFor={`custom-checkbox-${key}`}>
                          {label}
                        </label>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Tab>
    </Tabs>
  );
}
